import { useCallback, useEffect, useState } from 'react';
import { filter, isEmpty } from 'lodash';
import { t } from '@lingui/macro';
import IconButton from '@material-ui/core/IconButton';
import useStyles from '../panels/test-list-panel/TestListPanelStyles';
import { Ng1UniversalMonitor } from '../icon';
import useNg1DrillDownService from '../../services/Ng1DrillDownService';
import Ng1BeaconStepsDialog from './Ng1BeaconStepsDialog';
import { useParameterizedFilterStateById } from '../../stores/FilterStateStore';
import { timeRangeFilterId } from '../filters';

export function Ng1DrillDownButton({ agent, test }) {
    const [drillDownEnabled, setDrillDownEnabled] = useState(false);
    const { isTestDrillDownAllowed, isNpointDrillDownAllowed, drillDown } = useNg1DrillDownService();
    const [beaconSteps, setBeaconSteps] = useState([]);
    const [showDialog, setShowDialog] = useState(false);
    const [timeRange] = useParameterizedFilterStateById(timeRangeFilterId);

    const handleClick = useCallback(() => {
        if (test) {
            const enabledSteps = filter(test.beaconSteps, 'enabled');

            if (!isEmpty(enabledSteps)) {
                setBeaconSteps(enabledSteps);
                setShowDialog(true);
                return;
            }
        }

        drillDown(timeRange, test, agent);
    }, [timeRange, agent, test, drillDown]);

    useEffect(() => {
        if (agent && test) {
            setDrillDownEnabled(isTestDrillDownAllowed(test, agent) && isNpointDrillDownAllowed(agent));
        } else if (agent) {
            setDrillDownEnabled(isNpointDrillDownAllowed(agent));
        } else {
            setDrillDownEnabled(isTestDrillDownAllowed(test));
        }
    }, [agent, test, isTestDrillDownAllowed, isNpointDrillDownAllowed]);

    const classes = useStyles();

    return drillDownEnabled ? (
        <>
            <IconButton
                className={classes.ng1DrillDown}
                title={t`Launch nGeniusONE Smart Edge Service Monitor`}
                onClick={handleClick}
            >
                <Ng1UniversalMonitor />
            </IconButton>
            <Ng1BeaconStepsDialog
                beaconSteps={beaconSteps}
                updateSelection={(selections) => drillDown(timeRange, { locationKeyId: selections[0] }, agent)}
                showDialog={showDialog}
                setShowDialog={setShowDialog}
            />
        </>
    ) : null;
}
